import { SelectProps, SxProps, TextFieldProps as MUITextFieldProps, InputLabel, FormControl, FormHelperText } from '@mui/material'
import { FC } from 'react'
import { Dropdown } from '@pokemon/design-v2.dropdown'
import { TFunction, useTranslation } from 'react-i18next'
import { getTranslatedStates } from '../../utils/country_states'
import { Validator } from '../verify/validation'
import { TextField, TextFieldProps } from '@pokemon/design-v2.text-field'
import { MenuItem } from '@pokemon/design-v2.menu-item'

export const definedStateCountries: ReadonlyArray<String> = ['US', 'MX', 'CA']

const stateMenuItems = (countryCode: string, t: TFunction<'translation', undefined>) => {
  const states = getTranslatedStates(t)[countryCode]
  return Object.keys(states).map((state) => {
    return <MenuItem
            key={state}
            value={state}
        >
            {states[state]}
        </MenuItem>
  })
}

export const PTCSStateField: FC<Readonly<(SelectProps | MUITextFieldProps) & { id: string; errorText?: string; halfWidth?: boolean; countryCode: string, validators?: ReadonlyArray<Validator> }>> = ({
  countryCode,
  halfWidth,
  label,
  sx,
  id,
  errorText,
  ...props
}) => {
  const { t } = useTranslation()

  return (

    (definedStateCountries.includes(countryCode))
      ? <FormControl fullWidth>
                  <InputLabel
                    id={`${id}-label`}
                    sx={{ bgcolor: 'white', px: 1, pt: 0.25 }}
                    error={Boolean(errorText)}
                  >
                    {label}
                  </InputLabel>
                  <Dropdown
                    sx={[sx, { width: '100%' }] as SxProps}
                    {...props as SelectProps}
                    id={id}
                    labelId={`${id}-label`}
                    error={Boolean(errorText)}
                  >
                      {
                          stateMenuItems(countryCode, t)
                      }
                  </Dropdown>
                  {
                    errorText && <FormHelperText data-testid={`${id}-helper-text`} error={true}>
                      {errorText}
                    </FormHelperText>
                  }
              </FormControl>
      : <TextField
                  {...props as TextFieldProps}
                  id={id}
                  label={label}
                  errorText={errorText}
              />

  )
}
